@let totalSlides = content?.slides?.length || 0;

@if (content && totalSlides > 0) {
<div class="wrap-m wrap-s m-t-2 m-t-4-m m-t-4-s p-t-2 p-t-3-m p-t-3-s b-t b-col-5">
    <h3 class="p-b-1 p-b-2-s s1"
        *iCms="'title' of content; skipEmpty: true">&nbsp;</h3>
    <div class="swiper-pagination"
         [class]="uid"></div>
    <carousel [sizeClass]="'MS: swiper-overflow-visible'"
              [style.--carousel-slides-per-view-round]="slidesPerViewRound"
              [style.--carousel-slides-per-view]="slidesPerView"
              [style.--carousel-space-between.px]="spaceBetween"
              [slidesPerView]="slidesPerView"
              [slidesPerGroup]="1"
              [spaceBetween]="spaceBetween"
              [pagination]="{
                el: '.' + uid,
                enabled: true,
                clickable: true,
                dynamicBullets: totalSlides > 3
            }"
              [mousewheel]="!client.isTouchy">
        @for (slide of content.slides; track $index) {
        <ng-template carouselSlide>
            <div class="flex flex-middle p-a-2 bg-col-5 _item">
                <!--image-->
                <href [link]="slide.link">
                    <img [dfImage]="slide.image"
                         [ratio]="'ratio-1-1'"
                         [alt]="slide.title">
                </href>
                <href [link]="slide.link">
                    <!--title-->
                    <p class="s1 truncate"
                       *iCms="'title' of slide"
                       [attr.title]="slide.title"></p>

                    <!--text-->
                    <p class="p2"
                       *iCms="'copy' of slide"></p>
                </href>
            </div>
        </ng-template>
        }
    </carousel>
</div>
}